module.exports = "li.nav-item {\n    list-style-type: none;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/top-nav/top-nav.component.css
// module id = ./src/app/top-nav/top-nav.component.css
// module chunks = main